import { testimonials } from '@/mocks/comics';

export default function Testimonials() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block text-xs font-label text-foreground-500 uppercase tracking-wider mb-3">
            &bull; 读者好评
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
            万千读者的
            <br />
            真实选择
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((review) => (
            <div
              key={review.id}
              className="bg-background-100 rounded-2xl p-6 md:p-8 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-sm text-accent-500"></i>
                  </div>
                ))}
              </div>

              <blockquote className="flex-1 mb-5">
                <p className="text-sm text-foreground-700 leading-relaxed italic">
                  &ldquo;{review.content}&rdquo;
                </p>
              </blockquote>

              <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                <div className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center text-foreground-500 font-label text-sm font-semibold">
                  {review.username.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-label font-semibold text-foreground-900">
                    {review.username}
                  </p>
                  <div className="flex items-center gap-1.5 mt-0.5">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-check-double-line text-xs text-accent-500"></i>
                    </div>
                    <span className="text-xs text-foreground-500">
                      已追更 {review.chaptersRead} 话
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}